require('font-awesome/css/font-awesome.min.css')
require('bootstrap/dist/css/bootstrap-theme.css')
require('bootstrap/dist/css/bootstrap.css')
angular = require('angular')
require('angular-toasty/dist/angular-toasty.min.js')
require('angular-toasty/dist/angular-toasty.min.css')
require('angular-socket-io')
require('ng-tags-input/build/ng-tags-input.min.js')
require('ng-tags-input/build/ng-tags-input.bootstrap.min.css')
require('ng-tags-input/build/ng-tags-input.min.css')
require('angular-loading-bar/build/loading-bar.min.css')
require("angular-bootstrap-contextmenu")
require('./style.scss')
require("ngdraggable")
require("angular-timezone-selector")
require("chosen-js")
require("chosen-js/chosen.css")
# require("angular-material")
# require("angular-messages")
# require("angular-animate")

angular.module('cdms', [
  "angular-toasty"
  'btford.socket-io'
  "ngTagsInput"
  "ui.bootstrap.contextMenu"
  "ngDraggable"
  "angular-timezone-selector"
  # "ngMaterial"
  # "ngMessages"
  # "ngAnimate"
  require("angular-aria")
  require("angular-moment")
  require("angular-loading-bar")
  require("ng-file-upload")
  require('angular-cookies')
  require "ng-idle"
  require('angular-ui-router'), require('angular-ui-bootstrap'),
  require('./common/tags')
  require('./common/promise'), require('./common/resource'),
  require('./common/selector')
  require('./common/warning'), require('./common/editor')
  require('./common/clipboard')
  require('./component/menu'),
  require('./component/login'),
  require('./component/dashboard'),
  require('./component/tag'),
  require('./component/log'),
  require('./component/user'), require('./component/device'), require('./component/autoupdate')
  require('./component/resource'), require('./component/report'), require('./component/company')
  ])
  .constant 'config',
    api:
      url: "#{ngx_context}api"
  .config ($urlRouterProvider, $locationProvider, $httpProvider, toastyConfigProvider, KeepaliveProvider, IdleProvider)->
    KeepaliveProvider.interval 60
    $locationProvider.html5Mode true
    $urlRouterProvider.otherwise '/devices'

    $httpProvider.interceptors.push ($cookies, $q)->
      interceptor =
        responseError: (rejection)=>
          return $q.reject(rejection)
        request: (config) =>
          config.headers = config.headers or {}
          if $cookies.get('token')
            config.headers.Authorization = "Bearer #{$cookies.get('token')}"
          return config
      return interceptor


    toastyConfigProvider.setConfig
      theme: 'material'
      timeout: 10000
      clickToClose: true
      sound: false
  .run ($rootScope, $state, cfpLoadingBar, Idle, User)->
    $rootScope.$on '$stateChangeStart', (event, next, params) =>
      cfpLoadingBar.complete()
      if next.authenicate
        User.profile().$promise.then (user)->
          $rootScope.user = user
        .catch ()->
          $state.go "login"
      else
        User.profile().$promise.then (user)->
          $rootScope.user = user
          $state.go "devices"
    $rootScope.$on "Keepalive", ()->
      User.profile().$promise.catch (err)->
        User.logout()
    Idle.watch()

  .service 'socket', (socketFactory, $cookies) ->
    opts =
      path: "#{ngx_context}socket.io"
      query: "token=#{$cookies.get('token')}"
    io = require('socket.io-client')
    socket = io.connect "/angular", opts
    opt =
      ioSocket: socket

    return new socketFactory(opt)

  .filter 'bytes', ()->
    units = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB']
    (bytes, precision)->
      precision ?= 0
      number = Math.floor(Math.log(bytes) / Math.log(1024))
      "#{(bytes / Math.pow(1024, Math.floor(number))).toFixed(precision)} #{ units[number]}"






// WEBPACK FOOTER //
// ./src/app.coffee